import styled from 'styled-components';

import { Card, Col } from 'antd';

export const Section = styled(Col)`
  width: 100%;
  padding-bottom: 18px;
`;

export const SectionBloco = styled(Card)`
  width: 100%;
  border-radius: 4px;
  height: fit-content;
  .ant-card-body {
    padding: ${props => props.padding || 0};
  }
`;

export const TitulePage = styled.p`
  font-weight: 500;
  font-size: 28px;
  line-height: 33px;
  color: #001f2a;
  margin: 0;
`;
